export default __webpack_public_path__ + "ae93533cfddeb5a31040224997ce74a2.png";